import React, { Component } from 'react';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';
import { connect } from 'react-redux';
import { getExpendType } from '@store/modules/finance/expend_type';
import { getCompanyList } from '@store/modules/company_list';
import Modalshortfalls from '@comm/shortfalls';

import { queryLoanWorkflow, querySaveLoan } from '@api/finance/loan';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
      shortData: '',
      visible: false,
    };
  }

  componentDidMount() {
    const { dataInfo } = this.state;
    this.setState({ dataInfo });
    this.loanWorkflow();
    const { dispatch } = this.props;
    dispatch(getExpendType());
    dispatch(getCompanyList());
  }

  /**
   * 提交借款
   */
  handSubmit = item => {
    delete item.apportionType;
    this.saveLoan(item);
  };

  loanWorkflow = params => {
    const { instance } = this.state;
    queryLoanWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveLoan = item => {
    this.setState({
      isSubmitting: true,
    });
    querySaveLoan(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else if (res.message.indexOf('\n') === -1) {
        message.error(res.message);
      } else {
        this.setState({
          shortData: res.message,
          visible: true,
        });
      }
    });
  };

  hideModal = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const { isSubmitting, instance, shortData, visible } = this.state;
    return (
      <div>
        <FormBase
          data={this.state.dataInfo}
          handSubmit={this.handSubmit}
          isSubmitting={isSubmitting}
        />
        <Card>
          <Process instance={instance} />
        </Card>
        <Modalshortfalls data={shortData || ''} visible={visible} hideModal={this.hideModal} />
      </div>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Page);



// WEBPACK FOOTER //
// ./src/components/finance/loan/PageAdd.js